import withThemeDetailsSubscription from '../../HOCs/withThemeDetailsSubscription';
import withPlacesModalClose from '../../HOCs/withPlacesModalClose';
import Slide from './Slide';

const ThemesSlide = withThemeDetailsSubscription(withPlacesModalClose(Slide));

export default ThemesSlide;



// WEBPACK FOOTER //
// ./src/screens/Places/ThemesSlide.jsx